module.exports = __webpack_public_path__ + "img/img8.0e90d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img8.png
// module id = 217
// module chunks = 0